import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api"; // Koristimo Axios instance za API pozive
import "./LoginScreen.css";
import logo from "../assets/images/logo_cyber_112.png";

const LoginScreen = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
  
    try {
      const response = await API.post("/user/login", { username, password });
  
      if (response.data.succes) {
        localStorage.setItem("token", response.data.token); // Sprema token
        localStorage.setItem("userId", response.data.id);   // Sprema userId
        console.log("UserID postavljen u localStorage:", response.data.id); // Debug log
        navigate("/dash"); // Preusmjeravanje na Dashboard
      } else {
        setError("Invalid username or password");
      }
    } catch (err) {
      setError("Something went wrong. Please try again.");
    }
  };
  
  


  return (
    <div className="login-container">
      <div className="login-box">
        <img src={logo} alt="Logo" className="login-logo" />
        <h2 className="subtitle">Welcome Back!</h2>

        <form onSubmit={handleLogin}>
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="input-new3"
            autoFocus
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="input-new3"
          />

          {error && <p className="error-message">{error}</p>}

          <button className="login-button" type="submit">Log In</button>
        </form>

        <p className="signup-text">
          Don't have an account?{" "}
          <span onClick={() => navigate("/signup")} className="signup-link">
            Sign Up
          </span>
        </p>
      </div>
    </div>
  );
};

export default LoginScreen;